// extracted by mini-css-extract-plugin
export var legendIndicator = "_b5-1";
export var legendRight = "_b5-0";